// extracted by mini-css-extract-plugin
export var video = "VideoAndText-module--video--LtTGq";
export var videoWrapper = "VideoAndText-module--videoWrapper--p9CyX";
export var wrapper = "VideoAndText-module--wrapper--Tayep";